var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H14V11.25C14 10.1914 12.8121 9.3058 11.7535 9.3058C10.6949 9.3058 10 10.1914 10 11.25V18H6.00001V6H10V8C10.6623 6.92857 12.3564 6.23727 13.525 6.23727C15.9965 6.23727 18 8.2786 18 10.75V18ZM4 18H0V6H4V18ZM2.00001 0C3.10458 0 4.00001 0.89543 4.00001 2C4.00001 3.10457 3.10458 4 2.00001 4C0.89544 4 1.00136e-05 3.10457 1.00136e-05 2C1.00136e-05 0.89543 0.89544 0 2.00001 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H14V11.25C14 10.1914 12.8121 9.3058 11.7535 9.3058C10.6949 9.3058 10 10.1914 10 11.25V18H6.00001V6H10V8C10.6623 6.92857 12.3564 6.23727 13.525 6.23727C15.9965 6.23727 18 8.2786 18 10.75V18ZM4 18H0V6H4V18ZM2.00001 0C3.10458 0 4.00001 0.89543 4.00001 2C4.00001 3.10457 3.10458 4 2.00001 4C0.89544 4 1.00136e-05 3.10457 1.00136e-05 2C1.00136e-05 0.89543 0.89544 0 2.00001 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.adb69726.svg";
export { ForwardRef as ReactComponent };